<template>
  <div class="hy-order">
    <div class="order-cont" v-show="adminShow">
      <!--活动简介-->
      <div class="order-topTitle">
        <div class="title">
          <h5>{{conference.name}}</h5>
        </div>

        <div class="infotimes" style="margin-top:10px;" v-if="conference.organizers != ''">
          <span class="iconfont">&#xe671;</span>主办单位：{{conference.organizers}}
        </div>
        <!-- <div class="infotimes" v-if="conference.company != ''">
          <span class="iconfont">&#xe6bb;</span>承办单位：{{conference.company }}
        </div> -->
        <div class="infotimes infotimes_width_label_content" style="display: flex;" v-if="id != '5664' && conference.company != ''">
          <div class="label" style="display: block; white-space: nowrap">
              <span class="iconfont">&#xe6bb;</span>
              <span>承办单位：</span>
            </div>
            <div class="content" style=": flex; flex-direction: column; flex: auto;">
              <!-- <div v-for="(i, index) in conference.company?.split(' ')" :key="index">{{ i }}</div> -->
            </div>
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe67f;</span>会议时间：{{conference.start_time,'Y-M-D'|formatDates}}~{{conference.end_time,'Y-M-D'|formatDates}}
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe64d;</span>会议地点：{{conference.region}}{{conference.specific_address}}
        </div>



      </div>
      <!-- 购票列表-->
      <div class="order_piaozhong">
        <div class="title">
          <h5>会议报名</h5>
          <!-- <router-link class="rightNav iconfont" to="/">更多 &#xe619;</router-link>-->
        </div>
        <div class="order_cell">
          <div class="order_cell_items">
            <div class="piao_list">
              <div class="piao_items" v-for="(items,index) in conference.ticket" :key="index">
                <h5 class="piao_name">{{items.name}}</h5>
                <div class="piao_numbox">
                  <div class="l">
                    <span class="piao_price" v-if="conference.is_show_price">￥{{items.price}}/1人</span>
                  </div>
                  <div class="r">
                    <!--通过设置disabled属性来禁用步进器 integer  整数设置-->
                    <van-stepper v-model="cartbox.conf_ticket_arr[index].quantity" min="0" :max="cartbox.conf_ticket_arr[index].max_num" integer @change="change(cartbox.conf_ticket_arr[index])" @overlimit="overlimit(cartbox.conf_ticket_arr[index])" disable-input />
                    <span class="piao_num">剩余 {{cartbox.conf_ticket_arr[index].remaining_num - cartbox.conf_ticket_arr[index].quantity}} 个名额</span>
                  </div>
                </div>
                <div class="piao_info">
                  {{items.desc == ''?'暂无说明':items.desc}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--平行会议列表-->
      <div class="order_piaozhong" v-if="parallel.length > 0">
        <div class="title">
          <h5>平行论坛（可独立报名）</h5>
          <!-- <router-link class="rightNav iconfont" to="/">更多 &#xe619;</router-link>-->
        </div>
        <div class="order_cell">
          <div class="order_cell_items" v-for="(items,index2) in parallel">
            <div class="order_pxTitle">
              <h5 class="pxTitle">
                <van-icon class="checke_box" :class="cartbox.para_checked === index2 ? 'active':''" name="success" @click="p_click(index2)" />
                {{items.name}}
              </h5>
              <div class="infotimes">
                <span class="iconfont">&#xe67f;</span>{{items.start_time,'Y-M-D'|formatDates}}~{{items.end_time,'Y-M-D'|formatDates}}
              </div>
              <div class="infotimes">
                <span class="iconfont">&#xe64d;</span>{{items.region}}{{items.specific_address}}
              </div>
            </div>
            <div class="piao_list" v-if="cartbox.para_checked === index2">
              <div class="piao_items" v-for="(items2,index3) in items.ticket" :key="index3">
                <h5 class="piao_name">{{items2.ticket_name}}</h5>
                <div class="piao_numbox">
                  <div class="l">
                    <span class="piao_price" v-if="conference.is_show_price">￥{{items2.price}}/1人</span>
                  </div>
                  <div class="r">
                    <!--通过设置disabled属性来禁用步进器 integer  整数设置-->
                    <van-stepper v-model="cartbox.parallel_ticket_arr[index2].ticket[index3].quantity" min="0" :max="cartbox.parallel_ticket_arr[index2].ticket[index3].max_num" integer @change="change(cartbox.parallel_ticket_arr[index2].ticket[index3])" @overlimit="overlimit(cartbox.parallel_ticket_arr[index2].ticket[index3])" disable-input />
                    <span class="piao_num">剩余{{cartbox.parallel_ticket_arr[index2].ticket[index3].remaining_num - cartbox.parallel_ticket_arr[index2].ticket[index3].quantity}}个名额</span>
                  </div>
                </div>
                <div class="piao_info">
                  {{items2.desc == ''?'暂无说明':items2.desc}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--报名须知-->
      <div class="order_xuzhi">
        <div class="title">
          <h5>报名须知</h5>
        </div>
        <div class="xuzhi_info" v-html="conference.ticket_desc"> </div>
      </div>
    </div>
    <!--订单页底部提交栏-->
    <div class="order_addbtnbox">
      <div class="addbox">
        <div class="l" @click="show_orderBox()">
          <div class="top">合计：<span class="l_price">￥{{cartbox.carNumPrice.price}}</span></div>
          <div class="bottom">
            <span class="number">共 {{cartbox.carNumPrice.num}} 个名额</span>
            <span class="iconfont"><em>明细</em> &#xe61f;</span>
          </div>
        </div>
        <div class="r">
          <span class="order_btn" @click="piaoNextBtn()">下一步</span>
        </div>
      </div>
      <van-action-sheet v-model="order_show" title="订单明细">
        <div class="sheet_list" v-if="cartbox.carNumPrice.conf_ticket_num > 0">
          <p>主会议</p>
          <ul>
            <li v-for="(items,index) in cartbox.conf_ticket_arr" :key="index" v-if="items.quantity > 0">
              <span class="name">{{items.name}}</span>
              <span class="price"><em>￥{{items.price}}</em> x {{items.quantity}}</span>
            </li>
          </ul>
        </div>
        <div class="sheet_list" v-if="cartbox.carNumPrice.parallel_ticket_num > 0">
          <p>平行会议</p>
          <ul v-if=" cartbox.para_checked != ''">
            <li v-for="(items2,index3) in cartbox.parallel_ticket_arr[cartbox.para_checked].ticket" :key="index3" v-if="items2.quantity > 0">
              <span class="name">{{items2.name}}</span>
              <span class="price"><em>￥{{items2.price}}</em> x {{items2.quantity}}</span>
            </li>
          </ul>
        </div>
      </van-action-sheet>
    </div>
  </div>
</template>


<script>
  import {
    formatDates
  } from "../../assets/js/date";
  export default {
    data() {
      return {
        id: '',
        conference: {},
        parallel: [],
        order_show: false,
        footerNav: false,
        thisStatus: 0,
        cartbox: {
          carNumPrice: {
            num: 0,
            price: '0.00',
            conf_ticket_num: 0,
            parallel_ticket_num: 0,
            hotel_num: 0,
            repast_num: 0,
            conf_price: '0.00',
            parallel_price: '0.00',
            hotel_price: '0.00',
            repast_price: '0.00'
          },
          conf_ticket_arr: [],
          parallel_ticket_arr: [],
          para_checked: '',
        },
        adminShow:false,//权限判断
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    created: function() {
      var _this = this;
      _this.adminMerber();
      _this.id = parseInt(_this.$route.params.id);
      _this.loadEnroll();
      var getShare = JSON.parse(sessionStorage.getItem('hy_shareData' + _this.id));
      if (getShare != null) {
        _this.$WXConfig.wxShowMenu({
          ifshare: true,
          that: _this,
          data: getShare
        });
      } else {
        _this.$WXConfig.wxShowMenu({
          ifshare: true,
          that: _this,
          data: ''
        });
      }
    },
    methods: {
      //权限验证
      adminMerber() {
        var _this = this;
        let url = "/ac1/conference/memberInfo";
        let params = {};
        _this.$get(url, params).then(res => {
          if (res.code == 1) {
            _this.adminShow = true;
          }else{
            _this.$dialog.alert({
              title: '提示',
              message: res.msg,
            }).then(() => {
              // on close
            });
          }
        });
      },
      p_click(i) {
        var _this = this;
        if (_this.cartbox.para_checked !== i) {
          _this.cartbox.para_checked = i;
        } else {
          _this.cartbox.para_checked = '';
        }
        _this.changPiao();
      },
      //总结票价跟数量
      changPiao() {
        var _this = this;
        var conf_ticket_num = 0,
          parallel_ticket_num = 0,
          conf_price = 0.00,
          parallel_price = 0.00;
        _this.cartbox.conf_ticket_arr.forEach(v => {
          if (v.quantity > 0) {
            conf_ticket_num += v.quantity;
            conf_price += v.price * v.quantity;
          }
        });
        if (_this.cartbox.para_checked !== '') {
          var on_para = _this.cartbox.parallel_ticket_arr[_this.cartbox.para_checked];
          for (var i = 0; i < on_para.ticket.length; i++) {
            if (on_para.ticket[i].quantity > 0) {
              parallel_ticket_num += on_para.ticket[i].quantity;
              parallel_price += on_para.ticket[i].price * on_para.ticket[i].quantity;
            }
          }
        }
        _this.cartbox.carNumPrice.price = (conf_price + parallel_price).toFixed(2);
        _this.cartbox.carNumPrice.num = parallel_ticket_num + conf_ticket_num;
        _this.cartbox.carNumPrice.conf_ticket_num = conf_ticket_num;
        _this.cartbox.carNumPrice.parallel_ticket_num = parallel_ticket_num;
      },
      //修改票数
      change(e) {
        var _this = this;
        /* if(e.quantity == e.max_num){
          _this.$toast('此门票最多只能购买 '+e.max_num+' 张！');
         }*/
        /*  if(e.remaining_num-e.quantity == 0){
          _this.$toast('没有了！');
        }*/
        _this.changPiao();
      },
      overlimit(val) {
        /*  console.log(val);*/
        var _this = this;
        if (val.max_num == 0) {
          _this.$toast('此活动限制单用户报名数量，您已报名过此活动，请在我的订单中查看。');
          return false;
        }
        if (val.quantity == val.max_num) {
          if (val.quantity == val.remaining_num) {
            _this.$toast('没有名额了！');
          } else {
            _this.$toast('此活动限制单用户报名数量， 当前您最多可选数量为 ' + val.max_num);
            // _this.$toast('一个用户一场活动最多可购买 '+val.limit_number+' 张！');
          }

        }
      },
      //banner跳转方法
      goPath(path) {
        this.$router.push(path)
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      show_orderBox() {
        this.order_show = !this.order_show;
      },
      loadEnroll() {
        var _this = this;
        let url = "/ac1/enroll/chooseTicket";
        let params = {
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.conference = res.posts.conference;
            _this.parallel = res.posts.parallel;
            var getStorage = JSON.parse(sessionStorage.getItem('huiyi_orderlist' + _this.id));
            if (getStorage && _this.id == getStorage.id) {
              _this.cartbox.carNumPrice = getStorage.cartbox.carNumPrice;
              _this.cartbox.conf_ticket_arr = getStorage.cartbox.conf_ticket_arr;
              _this.cartbox.parallel_ticket_arr = getStorage.cartbox.parallel_ticket_arr;
              _this.cartbox.para_checked = getStorage.cartbox.para_checked;
              for (var j = 0; j < _this.cartbox.conf_ticket_arr.length; j++) {
                var v1 = _this.conference.ticket[j];
                _this.cartbox.conf_ticket_arr[j].member = [];
                _this.cartbox.conf_ticket_arr[j].remaining_num = (v1.number - v1.sold_num);
                _this.cartbox.conf_ticket_arr[j].max_num = ((v1.limit_number - v1.buy_num) >= (v1.number - v1.sold_num) ? (v1.number - v1.sold_num) : (v1.limit_number - v1.buy_num));
                _this.cartbox.conf_ticket_arr[j].limit_number = v1.limit_number;
                _this.cartbox.conf_ticket_arr[j].buy_num = v1.buy_num;
              }
              var listbox = [];
              for (var i = 0; i < res.posts.parallel.length; i++) {
                for (var h = 0; h < _this.cartbox.parallel_ticket_arr.length; h++) {
                  if (res.posts.parallel[i].parallel_id == _this.cartbox.parallel_ticket_arr[h].id) {
                    var list = _this.cartbox.parallel_ticket_arr[h];
                    for (var p = 0; p < res.posts.parallel[i].ticket.length; p++) {
                      var vs = _this.parallel[i].ticket[p];
                      list.ticket[p].max_num = ((vs.limit_number - vs.buy_num) >= (vs.number - vs.sold_num) ? (vs.number - vs.sold_num) : (vs.limit_number - vs.buy_num));
                      list.ticket[p].remaining_num = (vs.number - vs.sold_num);
                      list.ticket[p].limit_number = vs.limit_number;
                      list.ticket[p].buy_num = vs.buy_num;
                    }
                    listbox.push(list);
                  }
                }
              }
              _this.cartbox.parallel_ticket_arr = listbox;
            } else {
              _this.conference.ticket.forEach(v => {
                _this.cartbox.conf_ticket_arr.push(JSON.parse(JSON.stringify({
                  id: v.id,
                  name: v.name,
                  price: v.price,
                  quantity: 0,
                  remaining_num: (v.number - v.sold_num),
                  max_num: ((v.limit_number - v.buy_num) >= (v.number - v.sold_num) ? (v.number - v.sold_num) : (v.limit_number - v.buy_num)),
                  limit_number: v.limit_number,
                  buy_num: v.buy_num,
                  type: 20,
                  parallel: 0,
                  member: []
                })));
              });
              _this.parallel.forEach(v => {
                var list = [];
                for (var i = 0; i < v.ticket.length; i++) {
                  list.push({
                    id: v.ticket[i].ticket_id,
                    name: v.ticket[i].ticket_name,
                    price: v.ticket[i].price,
                    quantity: 0,
                    remaining_num: (v.ticket[i].number - v.ticket[i].sold_num),
                    max_num: ((v.ticket[i].limit_number - v.ticket[i].buy_num) >= (v.ticket[i].number - v.ticket[i].sold_num) ? (v.ticket[i].number - v.ticket[i].sold_num) : (v.ticket[i].limit_number - v.ticket[i].buy_num)),
                    limit_number: v.ticket[i].limit_number,
                    buy_num: v.ticket[i].buy_num,
                    type: 20
                  });
                }
                _this.cartbox.parallel_ticket_arr.push({
                  id: v.parallel_id,
                  ticket: JSON.parse(JSON.stringify(list))
                });
              });
            }
            if (_this.cartbox.conf_ticket_arr[0].quantity == 0 && _this.cartbox.conf_ticket_arr.length == 1 && _this.cartbox.conf_ticket_arr[0].max_num > 0) {
              _this.cartbox.conf_ticket_arr[0].quantity = 1;
              _this.changPiao();
            }
          }
        });
      },
      piaoNextBtn() {
        var _this = this;
        _this.changPiao();
        if (_this.cartbox.carNumPrice.num == 0) {
          _this.$toast('数量不能为0！');
          return false;
        }
        for (var h = 0; h < _this.cartbox.parallel_ticket_arr.length; h++) {
          if (_this.cartbox.para_checked !== h) {
            var on_para = _this.cartbox.parallel_ticket_arr[h];
            for (var i = 0; i < on_para.ticket.length; i++) {
              on_para.ticket[i].quantity = 0;
            }
          }
        }
        if (_this.cartbox.carNumPrice.conf_ticket_num == 0) {
          var conference = _this.parallel[_this.cartbox.para_checked],
            ids = conference.parallel_id;

          var conts = {
            id: ids,
            conference: conference,
            cartbox: _this.cartbox
          };
          sessionStorage.setItem('huiyi_orderlist' + ids, JSON.stringify(conts));
          _this.goPath('/addOrder02/' + ids);
        } else {
          var conts = {
            id: _this.id,
            conference: _this.conference,
            cartbox: _this.cartbox
          };
          sessionStorage.setItem('huiyi_orderlist' + _this.id, JSON.stringify(conts));
          _this.goPath('/addOrder02/' + _this.id);
        }
      }
    },
    mounted() {}
  }
</script>
<style lang="less" scoped>

</style>
</style>
